module.exports = "/_next/static/images/08007877593b576bddb33bdcff09de49-gift-illustration@3x.png";